import { BriefcaseBusiness } from "lucide-react";
import { AiOutlineCode } from "react-icons/ai";
import { FaFacebook, FaGithub, FaLinkedin } from "react-icons/fa";

export const socialData = [
  {
    id: 1,
    href: "https://www.facebook.com/monirhabderabby",
    target: "_facebook",
    icon: FaFacebook,
  },
  {
    id: 2,
    href: "https://www.linkedin.com/in/monirhabderabby",
    target: "_linkedin",
    icon: FaLinkedin,
  },
  {
    id: 3,
    href: "https://github.com/monirhabderabby",
    target: "_github",
    icon: FaGithub,
  },
  {
    id: 4,
    href: "https://leetcode.com/u/monirhrabby",
    target: "_leetcode",
    icon: AiOutlineCode,
  },
];

export const experiencesList = [
  {
    id: 1,
    company_name: "SA Technologies",
    location: "Dhaka, Uttara",
    responsibility: "Ensured completion of daily tasks related to data entry.",
    icon: BriefcaseBusiness,
    date: "Aug 2020 - Oct 2022",
  },
  {
    id: 2,
    company_name: "ITCO BD",
    location: "Mirpur, DOHS",
    responsibility:
      "Developed and maintained web applications using React.js, ensuring high performance and user-friendly interfaces",
    icon: BriefcaseBusiness,
    date: "Nov 2022 - July 2023",
  },
];
